/* ============================================================================
   LAH — PROVADOR POR IA (MetaKosmos / mKFashion)
   Tema: Testes de implementacao (5.0)

   Integracao em modo MANUAL da SDK. Isso e proposital: no modo automatico a
   SDK monta o proprio botao e ADICIONA AO CARRINHO sozinha — o que quebraria
   a Lahtref, porque aqui nenhuma armacao e vendida solta. Ao registrar
   mk.onAddToCart, o controle volta para nos: fechamos o provador e abrimos o
   fluxo de lentes.

   ============================================================================
   A SDK CARREGA SO NO PRIMEIRO CLIQUE
   ============================================================================
   Antes ela vinha no theme.liquid, em toda pagina do site, para todo visitante
   — inclusive quem nunca abre o provador. Traz rastreamento facial, uma das
   coisas mais pesadas que um navegador executa, e a pagina de produto ainda
   carrega um segundo provador (Auglio).

   Agora nada dela existe ate o cliente pedir.

   ============================================================================
   O BOTAO NAO E REESCRITO — corrigido
   ============================================================================
   Uma versao anterior trocava o texto do botao por "abrindo..." durante o
   carregamento. Dois problemas:

     O texto nao deveria aparecer — nao faz parte do desenho do botao.

     E, pior, escrever no textContent APAGA o icone: ele e um elemento filho, e
     substituir o texto do botao remove tudo que estava dentro. Era por isso
     que o icone sumia depois da primeira abertura.

   Agora o estado de carregamento e uma CLASSE. O CSS pode reagir a ela se um
   dia quisermos, mas o conteudo do botao nunca e tocado.

   ============================================================================
   POSICAO NO DESKTOP — restaurada
   ============================================================================
   O botao fica a direita da pilula do Auglio, cuja largura depende do texto
   injetado pelo script deles. Medimos em tempo de execucao. A reescrita
   anterior removeu isso e o botao voltou para o canto.

   O alinhamento mantem as protecoes contra o vazamento de memoria que existia
   aqui: liga UMA VEZ, observa apenas entrada e saida de elementos (nunca
   atributos, que criavam laco com a propria escrita de style) e so escreve
   quando o valor muda.
   ============================================================================ */

(function () {
    'use strict';

    var SDK_URL = 'https://unpkg.com/mk-sdk-git@1/dist/mk-sdk.js';

    var WRAP_SELECTOR = '.lah-mk-btn-wrap';
    var DESKTOP_WRAP_SELECTOR = '.lah-mk-btn-wrap--desktop';
    var AUGLIO_SELECTOR = '.auglio-tryon-btn-product-page';
    var MEDIA_SELECTOR = '.custom-product-medias';
    var LENS_BUTTON_SELECTOR = '.openProductLens';
    var READY_CLASS = 'lah-mk-ready';
    var LOADING_CLASS = 'is-loading';

    var GAP = 8;
    var AUGLIO_WAIT_MS = 6000;
    var AUGLIO_POLL_MS = 120;

    var MODAL_RATIO = 430 / 800;
    var MODAL_MAX_HEIGHT_DESKTOP = 720;

    var carregando = null;
    var preparado = false;
    var alinhamentoLigado = false;

    function getConfig() {
        var el = document.querySelector('[data-lah-mk-config]');
        if (!el) return null;

        return {
            projectId: el.getAttribute('data-mk-project-id') || '',
            identifier: el.getAttribute('data-mk-identifier') || ''
        };
    }

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function isDesktopViewport() {
        return window.matchMedia('(min-width: 1000px)').matches;
    }

    /* Tamanho do provador em funcao da tela, mantendo a proporcao original
       para o enquadramento do rosto continuar correto. */
    function getModalSize() {
        var vw = window.innerWidth;
        var vh = window.innerHeight;

        var height = isDesktopViewport()
            ? Math.min(MODAL_MAX_HEIGHT_DESKTOP, Math.round(vh * 0.86))
            : Math.round(vh * 0.92);

        var width = Math.round(height * MODAL_RATIO);
        var maxWidth = Math.round(vw * 0.94);

        if (width > maxWidth) {
            width = maxWidth;
            height = Math.round(width / MODAL_RATIO);
        }

        return { width: width, height: height };
    }

    /* =====================================================================
       POSICAO NO DESKTOP
       ===================================================================== */
    function getVisibleAuglio() {
        var auglio = document.querySelector(AUGLIO_SELECTOR);
        if (!auglio) return null;
        if (auglio.offsetParent === null) return null;
        if (!auglio.offsetWidth) return null;
        return auglio;
    }

    function waitForAuglio() {
        return new Promise(function (resolve) {
            var found = getVisibleAuglio();
            if (found) return resolve(found);

            var waited = 0;
            var timer = setInterval(function () {
                var el = getVisibleAuglio();
                if (el) {
                    clearInterval(timer);
                    resolve(el);
                    return;
                }
                waited += AUGLIO_POLL_MS;
                if (waited >= AUGLIO_WAIT_MS) {
                    clearInterval(timer);
                    resolve(null);
                }
            }, AUGLIO_POLL_MS);
        });
    }

    /* So escreve quando o valor muda: reposicionar para o mesmo lugar ainda
       conta como escrita e gera trabalho de layout. */
    function positionDesktopButton() {
        var wrap = document.querySelector(DESKTOP_WRAP_SELECTOR);
        if (!wrap) return;

        var auglio = getVisibleAuglio();

        var left = '15px';
        var top = '15px';

        if (auglio) {
            left = (auglio.offsetLeft + auglio.offsetWidth + GAP) + 'px';
            top = auglio.offsetTop + 'px';
        }

        if (wrap.style.left !== left) wrap.style.left = left;
        if (wrap.style.top !== top) wrap.style.top = top;
    }

    function keepDesktopButtonAligned() {
        if (!isDesktopViewport()) return;
        if (alinhamentoLigado) return;
        alinhamentoLigado = true;

        positionDesktopButton();

        var pendente = false;

        function agendar() {
            if (pendente) return;
            pendente = true;
            requestAnimationFrame(function () {
                pendente = false;
                positionDesktopButton();
            });
        }

        var auglio = getVisibleAuglio();

        if (auglio && window.ResizeObserver) {
            new ResizeObserver(agendar).observe(auglio);
        }

        /* SEM attributes: era o vigia de style que fechava o laco com a propria
           escrita de positionDesktopButton(). */
        var container = document.querySelector(MEDIA_SELECTOR);
        if (container && window.MutationObserver) {
            new MutationObserver(agendar).observe(container, {
                childList: true,
                subtree: true
            });
        }

        window.addEventListener('resize', agendar, { passive: true });
    }

    /* =====================================================================
       CARREGAMENTO DA SDK

       Uma promessa so, guardada: cliques repetidos durante o download nao
       baixam a SDK duas vezes.
       ===================================================================== */
    function carregarSdk(config) {
        if (carregando) return carregando;

        carregando = new Promise(function (resolve) {
            if (window.mk && window.mk._isMkSdk) return resolve(window.mk);

            var s = document.createElement('script');
            s.src = SDK_URL;
            s.async = true;
            s.setAttribute('data-mk-project', config.projectId);
            s.setAttribute('data-mk-product', 'mk-fashion');

            /* A SDK se registra em window.mk um instante depois do onload,
               entao esperamos por ela em vez de confiar no evento. */
            var esperou = 0;

            function procurar() {
                if (window.mk && window.mk._isMkSdk) return resolve(window.mk);

                esperou += 120;
                if (esperou >= 10000) return resolve(null);

                setTimeout(procurar, 120);
            }

            s.onload = procurar;
            s.onerror = function () { resolve(null); };

            document.head.appendChild(s);
        });

        return carregando;
    }

    /* Abre o configurador reaproveitando o botao existente da PDP, marcando
       antes a origem para o evento lens_flow_open. */
    function openLensFlow() {
        window.__lahLensSource = 'tryon_mk';

        var lensBtn = document.querySelector(LENS_BUTTON_SELECTOR);
        if (lensBtn) lensBtn.click();
    }

    /* Registrados UMA VEZ, antes da primeira abertura, como pede a doc.
       onAddToCart e o que impede o provador de vender armacao solta. */
    function prepararEventos(mk) {
        if (preparado) return;
        preparado = true;

        mk.onAddToCart(function (payload) {
            track('mk_cart_intercepted', {
                mk_sku: payload && payload.identifier,
                mk_size: payload && payload.size && payload.size.label
            });

            try { mk.close(); } catch (e) { /* ignora */ }

            setTimeout(openLensFlow, 150);
        });

        mk.onInteraction(function (data) {
            track('mk_' + data.category + '_' + data.action, {
                mk_sku: data.sku,
                mk_visitor_id: mk.getVisitorId(),
                mk: data
            });
        });

        mk.onError(function (err) {
            track('mk_error', { mk_message: err && err.message });
        });
    }

    /* =====================================================================
       CLIQUE
       ===================================================================== */
    function ligar() {
        var wraps = document.querySelectorAll(WRAP_SELECTOR);
        if (!wraps.length) return;

        var config = getConfig();
        if (!config || !config.projectId || !config.identifier) return;

        /* No desktop esperamos a pilula do Auglio existir antes de revelar, para
           o botao ja nascer na posicao certa em vez de saltar. */
        var pronto = isDesktopViewport() ? waitForAuglio() : Promise.resolve(null);

        pronto.then(function () {
            positionDesktopButton();

            requestAnimationFrame(function () {
                Array.prototype.forEach.call(wraps, function (wrap) {
                    wrap.classList.add('is-ready');
                });

                document.body.classList.add(READY_CLASS);

                keepDesktopButtonAligned();
            });
        });

        Array.prototype.forEach.call(wraps, function (wrap) {
            var btn = wrap.querySelector('.lah-mk-btn');
            if (!btn) return;

            btn.addEventListener('click', function () {
                if (btn.classList.contains(LOADING_CLASS)) return;

                track('mk_open_click', { mk_sku: config.identifier });

                /* Classe, nunca texto: escrever no botao apagaria o icone. */
                btn.classList.add(LOADING_CLASS);

                function devolver() {
                    btn.classList.remove(LOADING_CLASS);
                }

                carregarSdk(config).then(function (mk) {
                    if (!mk) {
                        devolver();
                        track('mk_error', { mk_message: 'sdk_nao_carregou' });
                        return;
                    }

                    prepararEventos(mk);

                    return mk.isAvailable(config.projectId, config.identifier)
                        .then(function (available) {
                            devolver();

                            if (!available) {
                                track('mk_error', { mk_message: 'modelo_sem_provador' });
                                return;
                            }

                            var size = getModalSize();

                            mk.open({
                                projectId: config.projectId,
                                identifier: config.identifier,
                                width: size.width,
                                height: size.height
                            });
                        });
                }).catch(function () {
                    devolver();
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ligar);
    } else {
        ligar();
    }
})();
